import styled from "styled-components";

import icons from "icons";
import * as Types from "Types";

const Wrap = styled.div<Types.Default>`
   display: flex;
   align-items: center;
   width: 23px;
   height: 23px;
   position: relative;
   ${({ css }) => css}
`;

const Icon = styled.img`
   position: absolute;
   opacity: 1;
   transition-duration: 0.3s;
   transition-property: opacity;
   transition-timing-function: ease-in-out;
   max-width: 100%;
   ${Wrap}:hover & {
      opacity: 0;
   }
`;
const IconHighlight = styled.img`
   position: absolute;
   opacity: 0;
   transition-duration: 0.3s;
   transition-property: opacity;
   transition-timing-function: ease-in-out;
   max-width: 100%;
   ${Wrap}:hover & {
      opacity: 1;
   }
`;

export default function SearchInput(props: Types.Default) {
   return (
      <Wrap css={props.css}>
         <Icon src={icons.search} alt="search"></Icon>
         <IconHighlight src={icons.searchHighlight} alt="search"></IconHighlight>
      </Wrap>
   );
}
